import { useContext } from 'react';
import { FormContext } from '@/form/FormContext.tsx';

export const useForm = () => {
  const context = useContext(FormContext);
  if (context === null) {
    throw Error('Form context is not defined');
  }
  return context;
};
